import React from 'react';
import Icon from './Icon';
import './EmptyState.css';

const EmptyState = ({ 
  icon = 'description',
  title = 'No data available',
  message = 'There are no items to display at the moment.',
  action,
  className = ''
}) => {
  return (
    <div className={`empty-state ${className}`}>
      <div className="empty-state-content">
        <div className="empty-state-icon">
          <Icon name={icon} size="xlarge" />
        </div>
        
        <div className="empty-state-text">
          <h3 className="empty-state-title">{title}</h3>
          <p className="empty-state-message">{message}</p>
        </div>
        
        {action && (
          <div className="empty-state-action">
            {action}
          </div>
        )}
      </div>
    </div>
  );
};

export default EmptyState;
